document.addEventListener('DOMContentLoaded', function () {

  const navLinks = document.querySelectorAll('.pdp-landing__nav-links a');
  const topBar = document.querySelector('.pdp-landing__title-nav-links');
  const bottomBar = document.querySelector('.pdp-landing__price-atc-button');
  const headerSection = document.querySelector('.pdp-landing-header-section');
  const sections = document.querySelectorAll('.nav-section[data-nav]');

  let lastScrollTop = window.pageYOffset;
  let scrollTimeout = null;
  let isScrollingDown = null;
  const headerPosition = headerSection.offsetTop;

  /* =========================
     SMOOTH SCROLL ON CLICK
  ========================== */
  navLinks.forEach(link => {
    link.addEventListener('click', function(e){
      e.preventDefault();
      const key = this.getAttribute('href').replace('#','');
      const firstSection = document.querySelector(`.nav-section[data-nav="${key}"]`);

      if(firstSection){
        window.scrollTo({
          top: firstSection.offsetTop - 80,
          behavior: 'smooth'
        });
      }
    });
  });

  /* =========================
     SCROLL HANDLER
  ========================== */
  window.addEventListener('scroll', function () {

    const scrollPos = window.pageYOffset;
    const scrollingDown = scrollPos > lastScrollTop;

    /* ---------- MOBILE ANIMATION ---------- */
    if (window.innerWidth <= 767 && topBar && bottomBar) {

      // Only react if direction changed
      if (scrollingDown !== isScrollingDown) {

        if (scrollingDown) {
          topBar.classList.add('hide');
          bottomBar.classList.add('hide');
        } else {
          bottomBar.classList.add('hide');
          topBar.classList.remove('hide');
        }

        isScrollingDown = scrollingDown;
      }

      // Detect scroll stop (run once)
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        topBar.classList.remove('hide');
        bottomBar.classList.remove('hide');
        isScrollingDown = null;
      }, 220);
    }

    /* ---------- DESKTOP STICKY ---------- */
    if(window.innerWidth >= 768 && headerSection){
      if(scrollPos > headerPosition){
        headerSection.classList.add('sticky');
      } else {
        headerSection.classList.remove('sticky');
      }
    }

    /* ---------- SCROLL SPY ---------- */
    if (sections.length) {
      const offset = window.innerWidth <= 767 && topBar ? topBar.offsetHeight : 0;
      const currentPos = scrollPos + offset + 180;

      let activeSet = false;

      navLinks.forEach(link => {
        const key = link.getAttribute('href').replace('#','');
        const group = document.querySelectorAll(`.nav-section[data-nav="${key}"]`);

        if (!group.length) return;

        const start = group[0].offsetTop;
        const last = group[group.length - 1];
        const end = last.offsetTop + last.offsetHeight;

        if (currentPos >= start && currentPos < end) {
          navLinks.forEach(l => l.classList.remove('active'));
          link.classList.add('active');
          activeSet = true;
        }
      });

      if (!activeSet) navLinks.forEach(l => l.classList.remove('active'));
    }

    lastScrollTop = scrollPos <= 0 ? 0 : scrollPos;

  }, { passive: true });

});